import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { Flowbite } from 'flowbite-react';

  const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
  const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      audience={`${AUTH0_AUDIENCE}/api/v2/`}
      clientId={AUTH0_CLIENT_ID}
      redirectUri={`${window.location.origin}/dashboard`}
    >
      <Flowbite>
        <App />
      </Flowbite>
    </Auth0Provider>
  </React.StrictMode>
);
